
import React from 'react';
import ReactDom from 'react-dom';

export class MetricSelector extends React.Component {

    constructor( props ){

        super( props );

        this.state = {
            ready: 0,
            variants:[],
            step: 0.1,
            selected_width: 0,
            selected_product: null,
            parent_product: null,
            quantity: 1,
            product: null,
        }

    }

    componentDidMount(){

        let variants = JSON.parse( document.getElementById('metric_material_variants').getAttribute('data-variants'));
        let step = document.getElementById('metric_material_variants').getAttribute('data-step');
        let product = document.getElementById('metric_material_variants').getAttribute('data-product');

        this.setState( { product, selected_product: variants[0].variation_id, step, variants, ready: 1 } );
        
    }

    renderAddToCartButton(){

        return(
            <form action={window.location.href} method="POST" encType="multipart/form-data">
                
                <input type="hidden" name="quantity" value={this.state.quantity} />
                <button type="submit" className="single_add_to_cart_button button alt go-to-shop">Dodaj do koszyka</button>
                <input type="hidden" name="add-to-cart" value={this.state.selected_product}/>
                <input type="hidden" name="product_id" value={this.state.selected_product}/>
                <input type="hidden" name="variation_id" className="variation_id" value={this.state.selected_product}/>
                
            </form>
        );        

    }


    selectVariant( variantID ){

        this.setState( {selected_product: variantID } );

    }

    displaySelectedImage(  ){

        let selected = this.state.variants.find( ( elem ) => { return elem.variation_id == this.state.selected_product });
        let image = document.getElementById('main-image');
        image.src = selected.image.full_src;
        return null;

    }

    displayVariantsData(){

        let variants = this.state.variants.map( ( elem ) => {
            
            return (

                <div onClick={ (e)=> { this.selectVariant( elem.variation_id ) } } className={"product-color-option " + (( elem.variation_id == this.state.selected_product) ? " selected":"" ) } style={ {backgroundImage: 'url('+elem.image.gallery_thumbnail_src+')'} }>
                </div>

            );

        });

        return variants;

    }

    displayInput(){

        let input = <div>
            <span>Ilość (w metrach):</span>
            <input className="length-product" onChange={ ( e ) => { this.setState( { quantity: e.target.value} ) } } type="number" value={this.state.quantity} step="0.1" min="0.5"/>
        </div>
        ReactDom.render( input, document.getElementById('input-selector'));
    }

    displayCurrentVariantPrice(){

        let selected = this.state.variants.find( ( elem ) => { return elem.variation_id == this.state.selected_product });
        document.getElementById('current-variant-price').innerHTML = selected.display_price + 'zł';
    }

    printSummary(){
        let selected = this.state.variants.find( ( elem ) => { return elem.variation_id == this.state.selected_product });
        let summary = <div className="summary">
            Podsumowanie: <span className="product-length">{ this.state.quantity } mb</span><span className="price-value"> { (parseFloat(selected.display_price) * this.state.quantity).toFixed(2)} zł</span>
        </div>

        ReactDom.render( summary, document.getElementById('quantity-of-product'));
        ReactDom.render( this.renderAddToCartButton(), document.getElementById('form-row-controller') );

    }

    displayVariants(){

        let variants = <div className="available-colours">
            <span>Wybierz wzór/kolor</span>
            {this.displayVariantsData()}
        </div>

        ReactDom.render( variants, document.getElementById('variant-selector') );

    }

    render(){

        if( this.state.ready ){
            
            let selected = this.state.variants.find( ( elem ) => { return elem.variation_id == this.state.selected_product });
            this.displayVariants();
            this.displaySelectedImage();
            this.displayInput();
            this.displayCurrentVariantPrice();
            this.printSummary();

            return (
              null
            );
        } else {

            return (null);

        }

    }

}


export class QuickMetricSelector extends React.Component {

    constructor( props ){

        super( props );

        this.state = {
            target: props.target,
            ready: 0,
            variants:[],
            step: 0.1,
            selected_width: 0,
            selected_product: null,
            parent_product: null,
            quantity: 1,
            product: null,
            name: ''
        }

    }

    componentDidMount(){

        
        let variants = JSON.parse( this.state.target.getAttribute('data-variants'));
        let step = this.state.target.getAttribute('data-step');
        let product = this.state.target.getAttribute('data-product');
        let name = this.state.target.getAttribute('data-name');

        this.setState( { name, product, selected_product: variants[0].variation_id, step, variants, ready: 1 } );
        
    }

    renderAddToCartButton(){

        return(
            <form action={window.location.href} method="POST" encType="multipart/form-data">
                
                <input type="hidden" name="quantity" value={this.state.quantity} />
                <button type="submit" className="single_add_to_cart_button button alt go-to-shop">Dodaj do koszyka</button>
                <input type="hidden" name="add-to-cart" value={this.state.selected_product}/>
                <input type="hidden" name="product_id" value={this.state.selected_product}/>
                <input type="hidden" name="variation_id" className="variation_id" value={this.state.selected_product}/>
                
            </form>
        );        

    }


    selectVariant( variantID ){

        this.setState( {selected_product: variantID } );

    }

    displaySelectedImage(  ){

        let selected = this.state.variants.find( ( elem ) => { return elem.variation_id == this.state.selected_product });
        
        return (
            <img src={ selected.image.full_src }/>
        );

    }

    displayVariants(){

        let variants = this.state.variants.map( ( elem ) => {
            
            return (

                <div onClick={ (e)=> { this.selectVariant( elem.variation_id ) } } className={"product-color-option " + (( elem.variation_id == this.state.selected_product) ? " selected":"" ) } style={ {backgroundImage: 'url('+elem.image.gallery_thumbnail_src+')'} }>
                </div>

            );

        });

        return variants;

    }

    render(){
        
        if( this.state.ready ){
            
            let selected = this.state.variants.find( ( elem ) => { return elem.variation_id == this.state.selected_product });

            return (
                <div className="row">
                    <div className="col-12 col-md-6">
                        {this.displaySelectedImage()}
                    </div>
                    <div className="col-12 col-md-6">
                    <h1 class="font-light">{this.state.name + ' - ' + selected.attributes[ Object.keys( selected.attributes )[0] ] }</h1>
        
                        <span>cena: {selected.display_price} zł / mb</span>
                        
                        <div className="available-colours">
                            <span>Wybierz wzór/kolor</span>
                            {this.displayVariants()}
                        </div>
                        <div>
                            <span>Ilość (w metrach):</span>
                            <input className="length-product" onChange={ ( e ) => { this.setState( { quantity: e.target.value} ) } } type="number" value={this.state.quantity} step="0.1" min="0.5"/>
                        </div>
                        <div className="summary">
                            Podsumowanie: <div><span className="product-length">{ this.state.quantity }/mb</span><span className="price-value"> { (parseFloat(selected.display_price) * this.state.quantity).toFixed(2)} zł</span></div>
                        </div>
                        {this.renderAddToCartButton()}
                        
                    </div>
                </div>
            );
        } else {

            return (<h1>Ładowanie :)</h1>);

        }

    }

}